<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <h3 class="is-size-3">
        <span>{{ software.name }}</span>
        <span class="has-text-weight-light"> - {{ version.version_number }}</span>
      </h3>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      <h4 class="is-size-4">Vulnerabilities</h4>
      <div class="box" v-for="finding in findings" :key="finding.id">
        <div class="columns">
          <div class="column">
            <vulnerable-title class="has-text-weight-bold" :type="finding.vulnerable_type" :vulnerable="finding.vulnerable"/>
            <vulnerable-description :type="finding.vulnerable_type" :vulnerable="finding.vulnerable"/>
            {{ finding.created_at | asCalendar }}

            <div class="mt-1" v-if="finding.output">
              <p class="has-text-weight-bold">Finding</p>
              <p>{{ finding.output }}</p>
            </div>

            <div v-if="finding.false_positive" class="mt-1">
              <p class="has-text-weight-bold">False Positive</p>
              <p>
                {{ finding.false_positive.type.description }}
              </p>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="is-flex justify-between has-text-right flex-column is-fullheight">
              <action-button v-if="!finding.resolved_at && !finding.false_positive" class="is-small" @click="markAsFalsePositive(finding)">False Positive</action-button>
              <div>
                <unresolved v-if="!finding.resolved_at && !finding.false_positive"/>
                <resolved v-if="finding.resolved_at"/>
                <false-positive v-if="finding.false_positive"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p v-if="!findings.length" class="mt-1">There are no vulnerabilities to display.</p>
    </div>
  </div>
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import { falsePositive } from '@/modals'
import { sortBy } from 'lodash'

export default {
  
  data: () => ({
    loading: true
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Software Manager')
    this.$store.dispatch('software/loadSoftware', {
      softwareId: this.$route.params.software,
      envId: this.$route.params.environment
    })
      .then(() => {
        this.loading = false
      })
  },

  methods: {
    markAsFalsePositive(finding) {
      falsePositive(finding)
    }
  },

  computed: {
    ...mapGetters('software', [
      'manager'
    ]),
    software() {
      return this.manager.software
    },
    version() {
      return this.manager.version
    },
    findings() {
      return sortBy(this.manager.findings, 'resolved_at').reverse()
    }
  }

}
</script>